import React from "react";
import ReactModal from "react-modal";
import { FiX } from "react-icons/fi";

// styles
import "./styles.scss";

function Modal({ isOpen, onRequestClose, children }) {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
      appElement={document.getElementById("root")}
    >
      <button
        type="button"
        onClick={onRequestClose}
        className="react-modal-close"
      >
        <FiX />
      </button>

      {children}
    </ReactModal>
  );
}

export default Modal;
